import { useMutation } from '@tanstack/react-query'
import axios from 'axios'

const AdminTasksEndpoints = {
  assignTask: (taskId: number) => `/tasks/${taskId}/assign_manually`,
}

export const useAssignTask = () => {
  return useMutation<void, Error, number>({
    mutationFn: async (taskId: number) => {
      const response = await axios.post(AdminTasksEndpoints.assignTask(taskId))
      return response.data
    },
  })
}
